module.exports = __webpack_public_path__ + "static/media/Footer Adornment.a4d1da4f.svg";